export class Slot
{
    position: number;
    color: string;
}


// WEBPACK FOOTER //
// ./src/app/+common/model/slot.model.ts